class NSSCollectionCarousels extends HTMLElement {

    constructor() {
        super();

        this.debug = false;

        this.tabs = this.querySelectorAll(`nss-collection-carousel`);

        this.tabButtons = this.querySelectorAll(`[nss-collection-carousel-tab-button]`)
    }

    connectedCallback() {
        if (this.debug) console.log("[NSS][Collection Carousels] Connected.");

        this.initTabs();
        this.checkWidth();

        const editorEvents = [
            `shopify:inspector:activate`,
            `shopify:inspector:deactivate`,
            `shopify:section:load`,
            `shopify:section:unload`,
            `shopify:section:select`,
            `shopify:section:deselect`,
            `shopify:section:reorder`,
            `shopify:block:select`,
            `shopify:block:deselect`,
        ]
        editorEvents.forEach((event) => {
            this.addEventListener(event, this.handleEditorEvent.bind(this));
        });
    }


    checkWidth() {
      /**
       * Magic numbers that need replaced:
       *   10 - This is the margin to the right of each li
       *   1092 - This is the minimum width before scrolling is necessary
       */
      const categoriesEl = this.querySelector(`.nss-collection-carousel-tab-controls`);
      if (categoriesEl) {
        const categoryEls = this.querySelectorAll(`.nss-collection-carousel-tab-controls button`);
        let totalWidth = 0;
        categoryEls.forEach((categoryEl) => {
          totalWidth += categoryEl.getBoundingClientRect().width + 10;
        });
        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        if (vw >= 1092 && totalWidth < 1092) {
          categoriesEl.classList.add(`nss-no-scroll`);
        } else {
          categoriesEl.classList.remove(`nss-no-scroll`);
        }
      }
    }

    initTabs() {
        const tabs = [...this.tabs];
        const tabButtons = [...this.tabButtons];
        tabs.forEach(tab => {
            const blockId = tab.getAttribute('data-block-id');
            const title = tab.getAttribute('data-title');
            if (blockId && title) {
                tabButtons.filter(button => button.getAttribute('data-block-id') == blockId).forEach(button => {
                    button.innerHTML = title;
                    button.addEventListener('click', () => {
                        if (button.classList.contains('is--active')) return;
                        const otherButtons = tabButtons.filter(otherButton => otherButton != button);
                        const otherTabs = tabs.filter(otherTab => otherTab != tab);
                        button.classList.add('is--active');
                        tab.classList.add('is--active');
                        otherButtons.forEach(otherButton => otherButton.classList.remove('is--active'));
                        otherTabs.forEach(otherTab => otherTab.classList.remove('is--active'));
                    });
                })
            }
        });

        this.classList.add('is--initialized');
    }

    handleEditorEvent(e) {
        if (this.debug) console.log("[NSS][Collection Carousels] Handle editor event, e:", e);

        switch (e.type) {

            case `shopify:block:select`:
                const tabEl = this.querySelector(`nss-collection-carousel[data-block-id="${e.detail.blockId}"]`);
                const tabButtonEl = this.querySelector(`[nss-collection-carousel][data-block-id="${e.detail.blockId}"]`);
                if (tabEl && tabButtonEl) {
                    const otherButtons = [...this.tabButtons].filter(otherButton => otherButton != tabButtonEl);
                    const otherTabs = [...this.tabs].filter(otherTab => otherTab != tabEl);
                    tabButtonEl.classList.add('is--active');
                    tabEl.classList.add('is--active');
                    otherButtons.forEach(otherButton => otherButton.classList.remove('is--active'));
                    otherTabs.forEach(otherTab => otherTab.classList.remove('is--active'));
                }
                break;

        }
    }
}

let elementName = `nss-collection-carousels`;
if (typeof customElements.get(elementName) === `undefined`) {
    customElements.define(elementName, NSSCollectionCarousels);
} else {
    console.warn(`[NSS] Element '${elementName}' already defined.`)
}